// Module
var code = `<div class="container">
  <div class="head">
    <div class="header edit-mode">
      <div class="icon-container"></div>
      <div class="title">\${this.title ?? ''}</div>
    </div>
    <div class="value-container"><div class="value"></div><div class="value-suffix">\${this.valueSuffix ?? ''}</div></div>
    <div class="footer">
      <div class="footer-title">\${this.footerTitle ?? ''}</div>
      <div class="footer-value">\${this.footerValue ?? ''}</div>
    </div>
  </div>
</div>
`;
// Exports
export default code;